import { z } from 'zod';

const jsonObjectSchema = z.record(z.string(), z.unknown());

function compactJsonObjects(value: unknown): unknown {
  if (!Array.isArray(value)) {
    return value;
  }

  return value.filter(
    (entry) =>
      entry !== null && typeof entry === 'object' && !Array.isArray(entry),
  );
}

export const rawLogRecordSchema = jsonObjectSchema.refine(
  (value) =>
    'payload' in value ||
    'messageType' in value ||
    'logId' in value ||
    'log_id' in value ||
    'Message' in value,
  { message: 'Expected a raw log object (payload, messageType, or log id)' },
);

export const linInputSchema = z.array(rawLogRecordSchema).min(1);

export const adieInputSchema = z.object({
  logs: z.preprocess(compactJsonObjects, z.array(jsonObjectSchema)),
  routing: jsonObjectSchema.optional(),
});

export const icsInputSchema = z.object({
  logs: z.preprocess(compactJsonObjects, z.array(jsonObjectSchema)),
  anomaly_events: z.preprocess(compactJsonObjects, z.array(jsonObjectSchema)),
  relations: z.preprocess(
    compactJsonObjects,
    z.array(jsonObjectSchema).optional(),
  ),
  routing: jsonObjectSchema.optional(),
});

const deIncidentInputSchema = z
  .object({
    incident_id: z.string().min(1),
    events: z.array(jsonObjectSchema).min(1),
  })
  .passthrough();

export const deInputSchema = z.preprocess((value) => {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return value;
  }

  const record = value as Record<string, unknown>;
  const incidentId =
    typeof record.incident_id === 'string'
      ? record.incident_id
      : typeof record.incidentId === 'string'
        ? record.incidentId
        : undefined;
  const events = Array.isArray(record.events)
    ? compactJsonObjects(record.events)
    : Array.isArray(record.Events)
      ? compactJsonObjects(record.Events)
      : undefined;

  return {
    ...record,
    incident_id: incidentId,
    events,
  };
}, deIncidentInputSchema);

export function formatZodError(error: z.ZodError): string {
  return error.issues.map((issue) => issue.message).join('; ');
}
